'use strict';

/**
 * @category   View
 * @module     settings
 * @copyright  Copyright (c) 2015, COLIDO (http://www.colido.net)
 * @author     Cengiz Mardin <cm@humans.am>
 */

var LayoutView = require('base/Colido.LayoutView');

var template = require('modules/settings/templates/modal/delete-account.hbs');

var DeleteAccountModalView = LayoutView.extend({
    template: template,

    className: 'settings settings-delete-account',

    ui: {
        closeButton: '[data-action="close"]',
        deleteButton: '[data-action="delete"]',
    },

    events: {
        'click @ui.closeButton': 'actionClose',
        'click @ui.deleteButton': 'actionDelete',
    },

    actionClose: function (event) {
        this.trigger('close:modal');
    },

    actionDelete: function(event){
        this.ui.deleteButton.addClass('is-loading').prop('disabled', true);
        var callbackSuccess = function(data) {
            this.ui.deleteButton.removeClass('is-loading').prop('disabled', false);
            this.ui.deleteButton.text(App.t('settings::account:delete:success'));
        }.bind(this);
        var callbackError = function(data) {
            this.ui.deleteButton.removeClass('is-loading').prop('disabled', false);

            Messenger().post({
                type: 'error',
                message: App.t('settings::account:unknown-error'),
            });
        }.bind(this);
        App.user.deleteAccount(App.user.get('id'), false, callbackSuccess, callbackError);
    },
});

module.exports = DeleteAccountModalView;